import { useQuery } from '@tanstack/react-query';
import { GetAdvisoriesParams, advisoryService } from '../../../services';

interface UseAdvisoriesOptions extends GetAdvisoriesParams {
  enabled?: boolean;
}

export function useAdvisories(options: UseAdvisoriesOptions = {}) {
  const { enabled = true, ...params } = options;

  return useQuery({
    queryKey: ['advisories', params],
    queryFn: async () => {
      const response = await advisoryService.getAdvisories(params);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar assessorias');
      }

      const apiData = response.data;
      const transformedAdvisories = apiData.data.map((party: any) => ({
        id: party.id,
        name: party.partyName,
        contactEmail: party.contactEmail || '',
        cnpj: party.organizationIdNumber || '',
        contactName: party.contactName || '',
        contactPhone: party.contactPhone || '',
        contactFullAddress: party.contactFullAddress || '',
        location: party.contactFullAddress || '',
        responsibleName: party.responsibleName || '',
        responsiblePhone: party.responsiblePhone || '',
        responsibleEmail: party.responsibleEmail || '',
        status: (party.partyStatus === '1' ? 'active' : 'inactive') as
          | 'active'
          | 'inactive',

        partyCode: party.partyCode,
        partyName: party.partyName,
        partyStatus: party.partyStatus,
        partyType: party.partyType,
        partyCategory: party.partyCategory,
        organizationIdNumber: party.organizationIdNumber,
        entityId: party.entityId,
        entityType: party.entityType,
        tenantCode: party.tenantCode,
      }));

      const transformedPagination = {
        page: apiData.meta.pageNumber,
        limit: apiData.meta.pageSize,
        total: apiData.meta.total,
        totalPages: apiData.meta.totalPages,
      };

      return {
        advisories: transformedAdvisories,
        pagination: transformedPagination,
      };
    },
    staleTime: 1000 * 60 * 5,
    enabled,
  });
}
